import React from 'react';
import SarasImage from '../../../../../library/input/image/SarasImage';
import { getSizedImageUrl } from '../../../../../helper/uiFunctions';

const PHOTO_HEIGHT = 96;

const parseStyle = (styleText, fallback) => {
    if (!styleText) return fallback;

    try {
        const parsed = JSON.parse(styleText);
        return {
            ...fallback,
            ...parsed
        };
    }
    catch (error) {
        return fallback;
    }
};

const formatPhotoDate = (dateText) => {
    if (!dateText) return '';

    const parts = dateText.split('-');
    if (parts.length === 3) {
        return `${parts[1]}-${parts[2]}`;
    }

    return dateText;
};

const ProdPlanGridItemPhoto = ({ viewData, onOpenDocument, onOpenLargeImage }) => {
    const documentCode = viewData?.docCode || viewData?.did || '';
    const qty = viewData?.qty || '';
    const planFinishDate = viewData?.planFinishDate || '';
    const imageUrl = getSizedImageUrl(viewData?.itemImage?.url || '', 'M');
    const imageName = viewData?.itemImage?.fileName || documentCode;
    const targetItem = viewData?.targetItem || {};
    const priority = viewData?.priority || {};

    const stripBaseStyle = {
        height: '5px',
        borderRadius: '0'
    };

    const type1StripStyle = parseStyle(targetItem.type1Style, {
        ...stripBaseStyle,
        background: '#2f6fed'
    });

    return (
        <div className='uiProdPlanPhotoCard'>
            <div className='uiProdPlanPhotoImageWrap'>
                <SarasImage
                    src={imageUrl}
                    alt={imageName}
                    height={`${PHOTO_HEIGHT}px`}
                    width='100%'
                    onClick={onOpenLargeImage}
                    style={{ cursor: onOpenLargeImage ? 'pointer' : 'default' }}
                />
                <div className='uiProdPlanPhotoStrips'>
                    <div title={targetItem.type1 || ''} style={type1StripStyle} />
                    <div
                        title={priority.name || ''}
                        className={priority.class || ''}
                        style={stripBaseStyle}
                    />
                </div>
            </div>

            <div className='uiProdPlanPhotoContent'>
                <div
                    onClick={onOpenDocument}
                    style={{
                        fontWeight: 700,
                        color: '#31435d',
                        lineHeight: '1.15',
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        cursor: onOpenDocument ? 'pointer' : 'default'
                    }}
                >
                    {documentCode}
                </div>
                <div
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        gap: '8px',
                        fontSize: '12px',
                        color: '#6a788e',
                        lineHeight: '1.15'
                    }}
                >
                    <span style={{ minWidth: '0', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                        {qty ? `${qty}` : ''}
                    </span>
                    <span style={{ whiteSpace: 'nowrap' }}>
                        {formatPhotoDate(planFinishDate)}
                    </span>
                </div>
            </div>
        </div>
    );
};

export default ProdPlanGridItemPhoto;
